import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';

export const syncImosGuids = (
    imosRotation: RotationPortCall[],
    stowageRotation: RotationPortCall[],
    imosRotationCargoList: RotationCargo[],
    stowagePlanRotationCargoList: RotationCargo[]
) => {
    syncRotationGuids(imosRotation, stowageRotation);
    syncCargoGuids(imosRotationCargoList, stowagePlanRotationCargoList);
};

const syncRotationGuids = (imosRotation: RotationPortCall[], stowageRotation: RotationPortCall[]) => {
    if (!imosRotation || !stowageRotation) return;

    // Build O(1) lookup maps instead of nested .find() calls
    const stowagePortCallMap = new Map<number, RotationPortCall>();
    const stowageBerthCallMap = new Map<number, { berthCall: RotationBerthCall; portCall: RotationPortCall }>();
    const stowageCargoOpMap = new Map<number, { cargoOp: RotationCargoOperation; berthCall: RotationBerthCall; portCall: RotationPortCall }>();

    for (const pc of stowageRotation) {
        if (pc.imosPortCallId != null) stowagePortCallMap.set(pc.imosPortCallId, pc);
        for (const bc of pc.berthCalls) {
            if (bc.imosBerthCallId != null) stowageBerthCallMap.set(bc.imosBerthCallId, { berthCall: bc, portCall: pc });
            for (const co of bc.cargoOperations) {
                if (co.imosCargoOperationId != null) stowageCargoOpMap.set(co.imosCargoOperationId, { cargoOp: co, berthCall: bc, portCall: pc });
            }
        }
    }

    for (const imosPortCall of imosRotation) {
        const stowagePortCall = stowagePortCallMap.get(imosPortCall.imosPortCallId);
        if (stowagePortCall && imosPortCall.portCallGuid !== stowagePortCall.portCallGuid) {
            imosPortCall.portCallGuid = stowagePortCall.portCallGuid;
        }
        for (const berthCall of imosPortCall.berthCalls) {
            const stowageBerthEntry = stowageBerthCallMap.get(berthCall.imosBerthCallId);
            const stowageBerthCall = stowageBerthEntry?.berthCall;
            if (stowageBerthCall && berthCall.berthCallGuid !== stowageBerthCall.berthCallGuid) {
                berthCall.berthCallGuid = stowageBerthCall.berthCallGuid;
            }
            if (stowagePortCall && berthCall.portCallGuid !== stowagePortCall.portCallGuid) {
                berthCall.portCallGuid = stowagePortCall.portCallGuid;
            }
            for (const cargoOperation of berthCall.cargoOperations) {
                const stowageCoEntry = stowageCargoOpMap.get(cargoOperation.imosCargoOperationId);
                const stowageCargoOperation = stowageCoEntry?.cargoOp;
                if (stowageCargoOperation && cargoOperation.cargoOperationGuid !== stowageCargoOperation.cargoOperationGuid) {
                    cargoOperation.cargoOperationGuid = stowageCargoOperation.cargoOperationGuid;
                }
                if (stowageBerthCall && cargoOperation.berthCallGuid !== stowageBerthCall.berthCallGuid) {
                    cargoOperation.berthCallGuid = stowageBerthCall.berthCallGuid;
                }
                if (stowagePortCall && cargoOperation.portCallGuid !== stowagePortCall.portCallGuid) {
                    cargoOperation.portCallGuid = stowagePortCall.portCallGuid;
                }

                if (cargoOperation.cargoGuid !== cargoOperation.cargo?.cargoGuid) {
                    cargoOperation.cargoGuid = cargoOperation.cargo?.cargoGuid;
                }
            }
        }
    }
};

const syncCargoGuids = (imosRotationCargoList: RotationCargo[], stowagePlanRotationCargoList: RotationCargo[]) => {
    if (!imosRotationCargoList || !stowagePlanRotationCargoList) return;

    const stowageCargoMap = new Map<number, RotationCargo>();
    for (const cargo of stowagePlanRotationCargoList) {
        if (cargo.imosCargoId != null) stowageCargoMap.set(cargo.imosCargoId, cargo);
    }

    for (const imosCargo of imosRotationCargoList) {
        const stowageCargo = stowageCargoMap.get(imosCargo.imosCargoId);
        if (stowageCargo && imosCargo.cargoGuid !== stowageCargo.cargoGuid) {
            imosCargo.cargoGuid = stowageCargo.cargoGuid;
        }
    }
};
